import apiFetch from '../apiFetch'

export default function (list, token) {
  return apiFetch({endPoint: `Informes/trazabilidad`, method: 'POST', body: list, token: token})
}